import React from 'react';
import { useTranslation } from 'react-i18next';
import { benefits } from '../../../utils/constants';
import classes from './Benefits.module.scss';
import { AiIcon, EasyApplyIcon, JobAlertsIcon, AppTrackingIcon } from '../Icons/benefits/index';

export default function Benefits({ passedBenefits, lightTheme = false }) {
  const { t } = useTranslation();

  const getBenefitData = (benefit, light) => {
    switch (benefit) {
      case benefits.AI:
        return {
          title: t('profile.builder.aijob'),
          image: <AiIcon light={light} />
        };
      case benefits.EASY_APPLY:
        return {
          title: t('profile.builder.oneclick'),
          // TODO We need a designer to make a normal SVG icons, then you can change the color
          image: <EasyApplyIcon light={light} />
        };
      case benefits.APP_TRACKING:
        return {
          title: t('profile.builder.applicationtracking'),
          // TODO We need a designer to make a normal SVG icons, then you can change the color
          image: <AppTrackingIcon light={light} />
        };
      case benefits.AUTO_JOB_ALERTS:
        return {
          title: t('profile.builder.automatedalert'),
          image: <JobAlertsIcon light={light} />
        };
      default:
        return {
          title: t('profile.builder.aijob'),
          image: <AiIcon />
        };
    }
  };

  return (
    <div className="d-flex flex-row flex-wrap justify-content-around gap-4">
      {passedBenefits.map((benefit) => {
        const benefitObject = getBenefitData(benefit, lightTheme);
        return (
          <div key={benefit} data-testid="benefit" className={classes.benefit}>
            {benefitObject.image}
            <p className={`text-center ${classes.title} ${!lightTheme ? classes.dark : ''}`}>{benefitObject.title}</p>
          </div>
        );
      })}
    </div>
  );
}
